const fr = {
	loading : `Chargement en cours…`,
	pause : `Pause`,
	play : `Lecture`,
	canonical : `Lien vers la fiche du sonore`,
	moment : `Lien vers ce moment`,

	untitled : `(sans titre)`,
	cover : `pochette`,
	more : `Actions`,
	share : `Partager`,
	twitter : `Partager sur Twitter`,
	facebook : `Partager sur Facebook`,
	e_mail : `Partager par e-mail`,
	download : `Télécharger`,
	back : `Annuler`,

	chapters : `Chapitres`,
	playlist : `Playlist`,

	media_err_aborted : `Vous avez annulé la lecture.`,
	media_err_network : `Une erreur réseau a causé l'interruption du téléchargement.`,
	media_err_decode : `La lecture du sonore a été annulée suite à des problèmes de corruption ou de fonctionnalités non supportés par votre navigateur.`,
	media_err_src_not_supported : `Le sonore n'a pu être chargé, soit à cause de sourcis sur le serveur, le réseau ou parce que le format n'est pas supporté.`,
	media_err_unknow : `Erreur due à une raison inconnue.`
};

export default fr;